import MousePosition from 'ol/control/MousePosition';

/**
 * MousePosition che ignora i mousemove finché la mappa non ha una size
 * calcolata: `Map.getEventPixel` fa `getSize()[0]` senza guardia e crasha se
 * il target è ancora staccato dal DOM o a dimensione 0, come al mount del
 * widget mappa (vedi `useMapExtendedView`: la mappa nasce su un nodo staccato).
 */
export class GuardedMousePosition extends MousePosition {
  protected override handleMouseMove(event: MouseEvent): void {
    if (this.getMap()?.getSize() == null) return;
    super.handleMouseMove(event);
  }
}
